export default __webpack_public_path__ + "static/media/01.23.25 Minutes Reg Mtg.8ca7166e.pdf";